module.exports = __webpack_public_path__ + "img/gb.abef6ce9.svg";